import { createAction } from '@mews/framework/redux';
import {
    AVAILABLE_OTHER_DATES_SUGGESTED,
    NO_AVAILABLE_OTHER_DATES_SUGGESTED,
} from '../../modules/otherDatesSuggestions/actionTypes';
import { CATEGORY_LIGHTBOX_OPENED } from './actionTypes';

export const openLightbox = () => createAction(CATEGORY_LIGHTBOX_OPENED);

export const createNoAvailableOtherDatesSuggestedAction = () => createAction(NO_AVAILABLE_OTHER_DATES_SUGGESTED);

export const createAvailableOtherDatesSuggestedAction = () => createAction(AVAILABLE_OTHER_DATES_SUGGESTED);
